import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lingking-group',
  templateUrl: './lingking-group.component.html',
  styleUrls: ['./lingking-group.component.scss']
})
export class LingkingGroupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
